export const maskEmailUsernames = (text: string | undefined) => {
  if (!text) {
    return '';
  }
  return text.replace(/\b([a-zA-Z0-9._%*+-]+)@([a-zA-Z0-9.-]+\.[a-zA-Z]{1,})\b/g, (match, user, domain) => `${'*'.repeat(user.length)}@${domain}`);
};

export const maskPhoneNumbers = (text: string | undefined) => {
  if (!text) {
    return '';
  }

  return text.replace(
    /\b(?:\+?\d{1,3}[-.\s])?(?:\(?\d{2,4}\)?[-.\s])?\d{2,4}[-.\s]\d{2,4}(?:[-.\s]\d{1,4})?\b|\b\d{7,15}\b/g,
    (match) => {
      const trimmed = match.trim();

      // Skip if it's part of a date pattern (YYYY-MM-DD, MM/DD/YYYY, etc.)
      const dateContext = /\b\d{1,4}[-/]\d{1,2}[-/]\d{1,4}\b/;
      if (dateContext.test(trimmed)) {
        return match;
      }

      // Skip if it's a currency amount (starts with currency symbol)
      const currencyContext = /[₹$€£]\s?\d/;
      const textBeforeMatch = text.substring(0, text.indexOf(match));
      if (currencyContext.test(textBeforeMatch + match.charAt(0))) {
        return match;
      }

      // Skip standalone numbers that are likely metrics (clicks, impressions, etc.)
      // These are usually isolated numbers not formatted like phone numbers
      if (/^\d{1,6}$/.test(trimmed) && !/[-.\s()]/.test(match)) {
        return match;
      }

      // Skip numbers with comma separators (like 1,934)
      if (/\d{1,3}(,\d{3})+/.test(trimmed)) {
        return match;
      }

      return match.replace(/\d/g, '*');
    }
  );
};

export const maskPII = (text: string) => {
  if (!text) {
    return '';
  }
  const maskedEmail = maskEmailUsernames(text);
  const maskedPII = maskPhoneNumbers(maskedEmail);
  return maskedPII;
};
